// you can see https://en.wikipedia.org/wiki/Aspect_ratio_(image)

enum AspectRatioDimensions {
  StandardRotated = '133.3%', // 3:4 non standart
  Full = '100%', // 1:1
  HD = '56.25%', // 16:9
  Standard = '75%', // 4:3
  Classic = '66.6%', // 3:2
  Univisium = '50%', // 2:1
  CinemaScope = '42.8%', // 21:9
  Panorama = '30%', // ~ 3.33:1
}

export { AspectRatioDimensions };
